<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13ehYOV/tc-custom/9781908117861.jpg?1705779180728" alt="This image is the cover for the book Heroes All"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heroes All
      </h1>
      <p class="bookDescription body article font2">
        <b>This WWII history shares the personal stories of frontline airmen from all sides of the conflict gathered through original interviews.</b><br/><br/> Aviation historian Steve Bond has spent years interviewing veterans of World War II. He recorded the stories of former airmen and crewmembers who shared the same pieces of sky at the same time. The project brought together British and German, German and Russian, British and Italian, American and German—sometimes literally.<br/><br/> In Heroes All, Bond presents the stories of these veterans—some of whom are household names—with annotations and overviews providing historical context. This is not a book about the rights and wrongs of war, nor the strategies of the military commanders. It is about the experiences and feelings of those on the front line.<br/><br/> This volume includes stories and recollections from veterans of the Air Transport Auxiliary, British Army, Fleet Air Arm, Italian air force, Luftwaffe, Royal Air Force, Royal Canadian Air Force and Navy, Soviet air force, US Army, US Army Air Force, US Navy, and other groupings.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Bond
      </h2>
      
      <p class="authorDescription body article">Dr Steve Bond is a life-long aviation professional and historian. He served in the Royal Air Force for twenty-two years as an aircraft propulsion technician, with tours on many different aircraft, and was part of the Eurofighter Typhoon project team in the MoD. A fellow of the Royal Aeronautical Society, he is also the author of many magazine articles and books including: Heroes All, Special Ops Liberators (with Richard Forder), Wimpy, Meteor Boys and Javelin Boys for Grub Street.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68176538